// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar-menu[data-v-e6858062]{justify-content:space-between!important}.navbar-end[data-v-e6858062],.navbar-start[data-v-e6858062]{margin-right:0!important;margin-left:0!important}.navbar-links[data-v-e6858062]{display:flex;align-items:center;grid-gap:16px;gap:16px}.navbar-links>a[data-v-e6858062]{flex-basis:content}nav.navbar .navbar-item[data-v-e6858062]{padding-right:0;padding-left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
